/**
 * Map candidate card status values to display text
 * Handles both interview statuses (SCHEDULED, RESCHEDULED, COMPLETED, etc.)
 * and offer letter statuses (GENERATED, ACCEPTED, INVOICED)
 */
export const formatCandidateCardStatus = (status: string): string => {
  const statusMap: Record<string, string> = {
    SCHEDULED: 'Interview Scheduled',
    RESCHEDULED: 'Interview Rescheduled',
    COMPLETED: 'Interview Completed',
    CANCELLED: 'Interview Cancelled',
    NO_SHOW: 'Candidate No Show',
    // Offer letter statuses
    GENERATED: 'Offer Generated',
    ACCEPTED: 'Offer Accepted',
    INVOICED: 'Offer Invoiced',
    SYSTEM_REJECTED: 'Offer system rejected',
    EXPIRED: 'Offer expired',
  };
  return statusMap[status] || status;
};
